import { GetFormatedDateStamp } from "../../../components/formatDate";

  const orderedFields = [
    'EmployeeID', 'FirstName', 'LastName', 'Email','PhoneNumbers' ,'EmpType', 'CreateDate', 'CreateBy','IsActive', 'DateOfBirth', 'Address', 'City', 
    'StateProvince', 'PostalCode', 'Country','Position','ReferredBy', 'EmergencyContactName', 'EmergencyContactRelationship', 
    'EmergencyContactPhone', 'HireDate', 'EmploymentStatus', 'DepartmentID', 'JobTitle', 
    'ProbationEndDate', 'DrivingLicenseValid', 'DrivingLicenseExpiryDate', 'WageAmount', 
    'WageType', 'ClockInOutRequired', 'ModifiedDate', 'ModifiedBy' 
];

export const ExportFilter = (dataList, departmentList) => {
    return dataList.map(data => {
        let orderedData = {};
        orderedFields.forEach(field => {
            // Match object keys with the respective field
            const fieldKey = field.charAt(0).toLowerCase() + field.slice(1); // convert to original object key format
            
            if(fieldKey === 'isActive'){
                orderedData['Status'] = data[fieldKey]? 'Active' : 'Inactive';
            }else if(fieldKey === 'departmentID'){
                orderedData['Department'] = departmentList?.find(x => x.key === data[fieldKey])?.value || '';
            }else if(fieldKey === 'position'){
                orderedData['EmployeeRole'] = data[fieldKey] || '';
            }else if(fieldKey === 'wageType'){
                orderedData['PaymentType'] = data[fieldKey] || '';
            }else{
                orderedData[field] = data[fieldKey] || '';
            }
        });
        return orderedData;
    });
};